// extracted by mini-css-extract-plugin
export var avatar = "_ry-3";
export var avatarContainer = "_ry-2";
export var avatarSpacer = "_ry-5";
export var avatarSpacerContainer = "_ry-4";
export var avatarStackContainer = "_ry-1";
export var bubble = "_ry-0";
export var remainderBubble = "_ry-6";